(function () {
  /* eslint-disable */
  RS.Modules.SearchHistory = {
    SEARCH_HISTORY_KEY: 'RS.Modules.SearchHistory.searchTerms',
    refSearchForm: null,
    refSearchHistory: null,
    refSearchHistoryList: null,
    refSearchTerm: null,
    predictiveSearchTermMinLength: null,

    isMpnSearch: function() {
      var isMpnSearch = (((window.rs || {}).web || {}).digitalData || {}).search_search_type || '';
      return isMpnSearch === 'MPN';
    },

    addSearchTermToHistory: function () {
      // BR-858 temporaily remove the storing the MPN tick box in SessionStorage
      var isMpnSearchChecked = RS.Modules.SearchHistory.isMpnSearch(); // RS.Modules.SearchBox.isMpnSearchChecked();
      if (isMpnSearchChecked || !(RS.Modules.SearchHistory.isSearchHistoryEnabled() && RS.Modules.SearchHistory.shouldSearchTermBeSaved())) {
        return;
      }

      var searchTerm = window.searchHistory.searchTermToAdd;

      var existingSearchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();

      var existingSearchTermKey = RS.Modules.SearchHistory.getSearchTermKeyFromHistory(existingSearchHistory, searchTerm);
      if (existingSearchTermKey) {
        delete existingSearchHistory[existingSearchTermKey];
      }

      existingSearchHistory = RS.Modules.SearchHistory.trimHistoryList(existingSearchHistory);
      existingSearchHistory[RS.Modules.SearchHistory.getTimestamp()] = searchTerm;
      RS.Utils.LocalStorage.setItem(RS.Modules.SearchHistory.SEARCH_HISTORY_KEY, JSON.stringify(existingSearchHistory));
    },

    bindListeners: function() {
      RS.Modules.SearchHistory.refSearchForm.mouseleave(function() {
        RS.Modules.SearchHistory.hideSearchHistory();
      });

      RS.Modules.SearchHistory.refSearchTerm.keydown(function(e) {
        RS.Modules.SearchHistory.keyboardNavigation(e);
      });

      RS.Modules.SearchHistory.refSearchTerm.keyup(function(e) {
        var escapeCode = e.charCode || e.keyCode;
        if (escapeCode !== 38 && escapeCode !== 40) { // Not up/down arrow keys
          RS.Modules.SearchHistory.showOrHideSearchHistory();
        }
      });

      RS.Modules.SearchHistory.refSearchTerm.focus(function() {
        RS.Modules.SearchHistory.showOrHideSearchHistory()
      })
    },

    executeSearchForItem: function(keyToSearch) {
      var existingSearchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();
      var searchTerm = existingSearchHistory[keyToSearch];
      RS.Modules.Analytics.addDeferredSearchEvent('header', searchTerm, 'searchHistory');
      RS.Modules.SearchHistory.refSearchTerm.val(searchTerm);
      RS.Modules.SearchHistory.refSearchForm.submit();
    },

    getReversedListOfKeys: function(searchHistory) {
      var keys;
      if (searchHistory) {
        keys = Object.keys(searchHistory).reverse();
      }
      return keys;
    },

    getSearchHistoryFromLocalStorage: function() {
      var existingSearchHistory = RS.Utils.LocalStorage.getItemWithoutExpiry(RS.Modules.SearchHistory.SEARCH_HISTORY_KEY);
      return existingSearchHistory ? JSON.parse(existingSearchHistory) : {};
    },

    getSearchHistory: function() {
      if (!RS.Modules.SearchHistory.isSearchHistoryEnabled()) {
        return null;
      }

      var searchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();

      var searchHistoryLastestFirst = [];
      if (searchHistory) {
        var searchHistoryReversedKeys = Object.keys(searchHistory).reverse();

        for (idx in searchHistoryReversedKeys) {
          var currentKey = searchHistoryReversedKeys[idx];
          var listItem = '<li data-seq="' + idx +'" data-key="'+ currentKey +'" class="search-history-item">'
              + '<span class="search-history-item-term">'+ searchHistory[currentKey] +'</span>'
              + '<i class="search-history-item-delete icon-rs_23-cross"></i>'
              + '</li>';
          searchHistoryLastestFirst.push(listItem);
        }
      }

      return searchHistoryLastestFirst;
    },

    getSearchTermKeyFromHistory: function(searchHistory, term) {
      var lcTerm = term.toLowerCase();
      var searchHistoryKeys = Object.keys(searchHistory);

      for (idx in searchHistoryKeys) {
        var currentKey = searchHistoryKeys[idx];
        var currentSearchTerm = searchHistory[currentKey].toLowerCase();

        if (currentSearchTerm === lcTerm) {
          return currentKey;
        }
      }

      return;
    },

    getTimestamp: function() {
      return Math.floor(Date.now() / 1000);
    },

    hideSearchHistory: function() {
      $('.search-history-item-delete').off('click');
      $('.search-history-item-term').off('click');
      $('.search-history-item.hovered').removeClass('hovered');
      RS.Modules.SearchHistory.refSearchHistory.hide();
    },

    init: function() {
      // Read the predictive search term minimum length, becuase the search history should is shown before the predictive search results start
      RS.Modules.SearchHistory.predictiveSearchTermMinLength = (((RS.Modules || {}).PredictiveSearch || {}).config || {}).searchTermMinLength || 2;

      RS.Modules.SearchHistory.refSearchHistory = $('#js-search-history');
      RS.Modules.SearchHistory.refSearchHistoryList = $('#js-search-history-list');
      RS.Modules.SearchHistory.refSearchForm = $('#searchForm');
      RS.Modules.SearchHistory.refSearchTerm = $('#searchTerm');

      RS.Modules.SearchHistory.bindListeners();
      RS.Modules.SearchHistory.addSearchTermToHistory();
    },

    isSearchHistoryEnabled: function() {
      return typeof window.searchHistory !== 'undefined' && typeof window.searchHistory.enabled !== 'undefined' && window.searchHistory.enabled && RS.Utils.LocalStorage.isAvailable();
    },

    isSearchHistoryItemHovered: function() {
      return $('.search-history-item.hovered').length;
    },

    keyboardNavigation: function(event) {
      var currentSeq = 0;
      var keyCode = event.charCode || event.keyCode;

      if ($('.search-history').is(":hidden")) {
        return;
      }

      switch (keyCode) {
        case 38:
        // up arrow
        if (RS.Modules.SearchHistory.isSearchHistoryItemHovered()) {
          currentSeq = parseInt($('.search-history-item.hovered').data('seq'));
          //unset active link
          $('.search-history-list li[data-seq="' + currentSeq + '"]').removeClass('hovered');
          if (currentSeq > 0) {
            currentSeq--;
            //set active link
            $('.search-history-list li[data-seq="' + currentSeq + '"]').addClass('hovered');
          }
        }
        break;

        case 40:
        // down arrow
        if (!RS.Modules.SearchHistory.isSearchHistoryItemHovered()) {
          // start with first
          $('.search-history-list li[data-seq="0"]').addClass('hovered');
        } else {
          currentSeq = parseInt($('.search-history-item.hovered').data('seq'));

          if ($('.search-history-list li[data-seq="' + (currentSeq + 1) + '"]').length) { // don't allow the user to go beyond the last search term in the list
            //unset active link
            $('.search-history-item.hovered').removeClass('hovered');
            currentSeq++;
            //set active link
            $('.search-history-list li[data-seq="' + currentSeq + '"]').addClass('hovered');
          }
        }

        break;

        case 13:
        //enter key
        if (RS.Modules.SearchHistory.isSearchHistoryItemHovered()) {
          var keyToSearch = $('.search-history-item.hovered').data('key');
          RS.Modules.SearchHistory.executeSearchForItem(keyToSearch);
        }
      };
    },

    removeSearchTermFromHistory: function(keyToRemove) {
      var existingSearchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();
      delete existingSearchHistory[keyToRemove];

      RS.Utils.LocalStorage.setItem(RS.Modules.SearchHistory.SEARCH_HISTORY_KEY, JSON.stringify(existingSearchHistory));

      $('li[data-key="'+ keyToRemove +'"]').hide();

      if (Object.keys(existingSearchHistory).length === 0) {
        RS.Modules.SearchHistory.hideSearchHistory();
      }
    },

    shouldSearchTermBeSaved: function() {
      return typeof window.searchHistory !== 'undefined'
            && typeof window.searchHistory.searchTermToAdd !== 'undefined';
    },

    showOrHideSearchHistory: function() {
      var searchTerm = RS.Modules.SearchHistory.trimSpaces(RS.Modules.SearchHistory.refSearchTerm.val());
      var isMpnSearchChecked = RS.Modules.SearchBox.isMpnSearchChecked();
      // The search history is shown before the predictive search results, predictive search only starts when the user enters 3 or more chars
      if (!isMpnSearchChecked && (searchTerm === 'undefined' || searchTerm.length <= RS.Modules.SearchHistory.predictiveSearchTermMinLength)) {
        var searchHistoryList = RS.Modules.SearchHistory.getSearchHistory();
        if (searchHistoryList !== null && searchHistoryList.length) {
          RS.Modules.SearchHistory.refSearchHistoryList.html(searchHistoryList);

          $('.search-history-item-delete').on('click', function(event) {
            var keyToRemove = $(event.target).parent().data('key');
            RS.Modules.SearchHistory.removeSearchTermFromHistory(keyToRemove);
          });

          $('.search-history-item-term').on('click', function(event) {
            var keyToSearch = $(event.target).parent().data('key');
            RS.Modules.SearchHistory.executeSearchForItem(keyToSearch);
          });

          RS.Modules.SearchHistory.refSearchHistory.show();
          return;
        }
      }

      RS.Modules.SearchHistory.hideSearchHistory();
    },

    trimHistoryList: function(searchHistory) {
      var trimmedSearchHistory = searchHistory;
      var shReversedKeys = this.getReversedListOfKeys(searchHistory);

      if (shReversedKeys.length === 5) {
        delete trimmedSearchHistory[shReversedKeys[4]];
      }

      return trimmedSearchHistory;
    },

    trimSpaces: function(searchTerm){
      if (searchTerm != null) {
        searchTerm = searchTerm.replace ( /^\s+/g, "" );// strip leading
        searchTerm = searchTerm.replace ( /\s+$/g, "" );// strip trailing
        searchTerm = searchTerm.replace ( /\s+/g, " " );// replace multiple with single
      }

      return searchTerm;
    },
  };
}());

(function () {
  RS.Modules.SearchHistory.init();
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/searchHistory.js
// module id = 328
// module chunks = 5